export function isInViewport(elem: JQuery<HTMLElement>): boolean {
    const elementTop = elem.offset().top;
    const elementBottom = elementTop + elem.outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}
